module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topic-container"
  }, [_c('div', {
    staticClass: "basic-info"
  }, [_c('div', {
    staticClass: "head"
  }, [(_vm.topicInfo.is_top) ? _c('img', {
    staticClass: "top",
    attrs: {
      "src": require("../../images/community/top.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.topicInfo.is_refining) ? _c('span', {
    staticClass: "tag featured"
  }, [_vm._v("精选")]) : _vm._e(), _vm._v(" "), (_vm.topicInfo.comment_is_accept_by_topic) ? _c('span', {
    staticClass: "tag solved"
  }, [_vm._v("已解决")]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "question-name",
    on: {
      "click": function($event) {
        return _vm.goQuestionDetail(_vm.topicInfo)
      }
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.filterXSS(_vm.topicInfo.afterHtmlTitle || _vm.topicInfo.title))
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, _vm._l((_vm.topicInfo.tags), function(i, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.tagSelector(i)
        }
      }
    }, [_vm._v("\n                " + _vm._s(i.title) + "\n            ")])
  }), 0), _vm._v(" "), (_vm.topicInfo.no_of_comment) ? _c('div', {
    staticClass: "question-content-wrapper"
  }, [_c('div', {
    ref: "descHook",
    staticClass: "question-desc img-hook",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": ("virtual-dom-" + (_vm.topicInfo.id))
    },
    domProps: {
      "innerHTML": _vm._s(_vm.filterXSS(_vm.topicInfo.afterhtmlData))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "comment-content-wrapper",
    on: {
      "click": function($event) {
        return _vm.goDetailComment(_vm.topicInfo, _vm.index)
      }
    }
  }, [(!_vm.topicInfo.isMatchComment) ? _c('div', {
    staticClass: "user-content-wrapper"
  }, [_c('el-popover', {
    attrs: {
      "popper-class": "user-card",
      "placement": "top",
      "open-delay": 500,
      "width": "400",
      "trigger": "hover"
    },
    on: {
      "show": function($event) {
        _vm.$refs['card' + _vm.topicInfo.comment_user.id + _vm.topIndex].getUserInfo()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0, padding: 0"
    }
  }, [_c('user-card', {
    ref: ("card" + (_vm.topicInfo.comment_user.id) + _vm.topIndex),
    attrs: {
      "user-id": _vm.topicInfo.comment_user.id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-avatar",
    attrs: {
      "slot": "reference"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    },
    slot: "reference"
  }, [(_vm.topicInfo.comment_user.user_logo.substr(0, 1) == '?') ? _c('img', {
    staticClass: "identity-icon",
    attrs: {
      "src": require("../../images/personal_center/avatar_default.png")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goHomePage(_vm.topicInfo.comment_user)
      }
    }
  }) : _c('img', {
    staticClass: "identity-icon",
    attrs: {
      "src": _vm.topicInfo.comment_user.user_logo,
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goHomePage(_vm.topicInfo.comment_user)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text name",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goHomePage(_vm.topicInfo.comment_user)
      }
    }
  }, [_vm._v(_vm._s(_vm.topicInfo.comment_user.nick_name))])])]), _vm._v(" "), (_vm.topicInfo.comment_user.is_official) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "蓝鲸智云官方",
      "placement": "right"
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-lanjingguanfang"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.topicInfo.comment_user.is_vip) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "核心用户",
      "placement": "right"
    }
  }, [_c('span', {
    staticClass: "icon-vipuser"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.getTime(_vm.topicInfo.comment_created_on)) + "回答")]), _vm._v(" "), (_vm.topicInfo.comment_is_accept_by_topic) ? _c('span', {
    staticClass: "tag adopted"
  }, [_vm._v("已采纳")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "comment-specific-wrapper"
  }, [(!_vm.topicInfo.isMatchComment) ? _c('p', {
    class: ['comment-left', {
      'active': _vm.topicInfo.is_approval
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onApproval(_vm.topicInfo)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.topicInfo.comment_up_list.length))]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.topicInfo.is_approval ? '已赞' : '赞同'))])]) : _vm._e(), _vm._v(" "), (!_vm.topicInfo.isMatchComment && _vm.topicInfo.show_image.length) ? _c('p', {
    staticClass: "comment-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.topicInfo.show_image[0].access_url
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.topicInfo.comment) ? _c('div', {
    class: ['comment-desc', _vm.topicInfo.isAllComment ? 'pack-up' : 'ellipsis']
  }, [_c('span', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.filterXSS(_vm.topicInfo.comment))
    }
  }), _vm._v(" "), (_vm.topicInfo.isShowAllComment) ? [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onShowAllComment(_vm.topicInfo.id)
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.topicInfo.isAllComment ? '收起' : '查看详情') + "\n                                "), _c('i', {
    class: ("el-icon-arrow-" + (_vm.topicInfo.isAllComment ? 'up' : 'down'))
  })]), _vm._v(" "), (_vm.fixedCommentId === _vm.topicInfo.id) ? _c('p', {
    staticClass: "fixed-bottom",
    style: (_vm.getCommentCollapsePos()),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onShowAllComment(_vm.topicInfo.id)
      }
    }
  }, [_vm._v("\n                                收起\n                                "), _c('i', {
    staticClass: "el-icon-arrow-up"
  })]) : _vm._e()] : _vm._e()], 2) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "comment-bottom-content"
  }, [_c('div', {
    staticClass: "footer-list"
  }, [(_vm.isSearch) ? _c('div', {
    staticClass: "answer-type"
  }, [_vm._v("问答")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "footer-item answer default",
    class: {
      'gray': !_vm.topicInfo.is_me_comment
    },
    on: {
      "click": function($event) {
        return _vm.goQuestionDetail(_vm.topicInfo, true)
      }
    }
  }, [_c('i', {
    staticClass: "answer-icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.topicInfo.no_of_comment)), _c('i', {
    staticClass: "text"
  }, [_vm._v("回答")])])]), _vm._v(" "), _c('p', {
    staticClass: "footer-item view default"
  }, [_c('i', {
    staticClass: "smart-icon view-icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("transformUnit")(_vm.topicInfo.no_of_views))), _c('i', {
    staticClass: "text"
  }, [_vm._v("阅览")])])]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.topicInfo.is_followed ? '取消关注' : '关注问题',
      "placement": "top"
    }
  }, [_c('p', {
    class: ['footer-item', {
      'is-active': _vm.topicInfo.is_followed
    }],
    on: {
      "click": function($event) {
        return _vm.focusToggle(_vm.topicInfo)
      }
    }
  }, [_c('i', {
    staticClass: "smart-icon follow-icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.topicInfo.no_of_followed)), _c('i', {
    staticClass: "text"
  }, [_vm._v("关注")])])])])], 1), _vm._v(" "), _c('p', {
    staticClass: "topic-people"
  }, [_c('el-popover', {
    attrs: {
      "popper-class": "user-card",
      "placement": "top",
      "open-delay": 500,
      "width": "400",
      "trigger": "hover"
    },
    on: {
      "show": function($event) {
        _vm.$refs['card' + _vm.topicInfo.created_by.id].getUserInfo()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0, padding: 0"
    }
  }, [_c('user-card', {
    ref: ("card" + (_vm.topicInfo.created_by.id)),
    attrs: {
      "user-id": _vm.topicInfo.created_by.id
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-avatar",
    attrs: {
      "slot": "reference"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    },
    slot: "reference"
  }, [(_vm.topicInfo.created_by.user_logo.substr(0, 1) == '?') ? _c('img', {
    staticClass: "create-user-logo",
    attrs: {
      "src": require("../../images/personal_center/avatar_default.png")
    },
    on: {
      "click": function($event) {
        return _vm.goHomePage(_vm.topicInfo.created_by)
      }
    }
  }) : _c('img', {
    staticClass: "create-user-logo",
    attrs: {
      "src": _vm.topicInfo.created_by.user_logo,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.goHomePage(_vm.topicInfo.created_by)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "create-user-name",
    domProps: {
      "innerHTML": _vm._s(_vm.filterXSS(_vm.topicInfo.afterHtmlName))
    },
    on: {
      "click": function($event) {
        return _vm.goHomePage(_vm.topicInfo.created_by)
      }
    }
  })])]), _vm._v(" "), (_vm.topicInfo.created_by.is_official) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "蓝鲸智云官方",
      "placement": "right"
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-lanjingguanfang"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.topicInfo.created_by.is_vip) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "核心用户",
      "placement": "right"
    }
  }, [_c('span', {
    staticClass: "icon-vipuser"
  })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" 于 " + _vm._s(_vm.topicInfo.created_on) + "发布")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-61447ff4!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/community/topicContainer.vue
// module id = hi88
// module chunks = 15